<template>
  <div class="text-center">
    <div class="mx-auto my-12" width="350" flat>
      <div v-if="isLoggedIn">
        <div class="text-h4">Hello {{ stored_login }}</div>
        <v-card-text>You are logged in</v-card-text>
        <div v-if="!isSubscribed">
          . . . But you do not have an active subscription to EyeDock Pro.<br /><br />Click
          below to subscribe
          <user-login class="ma-4"></user-login>
        </div>
      </div>
      <div v-else>
        <div v-if="msg == 'thanks'">
          <div class="text-h4">Thank you for signing up!</div>
          <div class="my-2">
            Sorry, you'll have to log in again (should be the last time, I
            swear!)
          </div>
        </div>
        <div v-else class="text-h4">You are logged out</div>
        <v-card-text>
          <user-login v-if="!isLoggedIn" :redirect="redirect"></user-login>
        </v-card-text>
      </div>
    </div>
    <!-- {{ redirect }} -->
  </div>
</template>

<script>
import UserMixin from "@/assets/js/UserMixin";
import UserLogin from "@/components/universalStuff/UserLogin.vue";
// import Name from "../dir/file";

export default {
  name: "LoginLogout",
  components: { UserLogin },
  mixins: [UserMixin],
  props: {},
  data: function () {
    return {
      action: null,
      redirect: null,
      msg: null,
    };
  },
  methods: {},
  computed: {},
  mounted() {
    let action = this.$route?.params?.action;
    if (action == "logout") this.logoutUser();
    this.redirect = this.$route?.query?.redirect ?? "/home";
    this.msg = this.$route?.query?.msg;
  },
};
</script>

<style scoped></style>
